<script setup>
const props = defineProps({
	item: {
		type: Object,
		required: true
	}
});

const {
	addItemExclusive,
	isItemAdded,
	toggleItem,
	closeDropdown,
	isMaxIatasAdded,
	isItemHovered,
	setHoveredItem
} = inject('searchFieldMultiHelpers');

function onRowClick (item, parentMetro = null) {
	addItemExclusive(item, parentMetro);
	closeDropdown();
}

const isHovered = computed(() => isItemHovered(props.item));

function onMouseEnter () {
	setHoveredItem(props.item);
}

</script>

<template>
  <div
    class="SearchFieldMulti__metro_wrapper"
  >
    <div
      class="SearchFieldMulti__row"
      :class="{
        'SearchFieldMulti__row--hovered': isHovered,
      }"
      @pointermove="onMouseEnter"
      @click.stop.prevent="onRowClick(item)"
    >
      <div class="SearchFieldMulti__row__inner">
        <span class="searchfield-icons-city" />
        <span v-html="item.text" />
      </div>
      <div
        class="SearchFieldMulti__checkbox"
        :class="{
          'SearchFieldMulti__checkbox--checked': isItemAdded(item, true),
          'SearchFieldMulti__checkbox--disabled': !isItemAdded(item, true) && isMaxIatasAdded
        }"
        @click.stop.prevent="toggleItem(item, null)"
        @touchend.prevent="toggleItem(item, null)"
      >
        <div class="SearchFieldMulti__checkbox__icon">
          +
        </div>
      </div>
    </div>
    <template
      v-for="(child, childIndex) in item.children"
      :key="childIndex"
    >
      <SearchFieldMultiAirport
        :item="child"
        :parent="item"
      />
    </template>
  </div>
</template>
